<div class="center-container">
    <img src="assets/404.png" [alt]="'common.labels.logo' | transloco" class="logo">
    <br />
    <span class="message">{{ 'pageNotFound.thePageYouAreLookingFor' | transloco }}</span>
</div>